import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logic|Credentials Grant Extension|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCertLogicGrantExtension';
export type SPCatalogCertLogicGrantExtensionLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonHide`
	| `${LocNameStart}ButtonShow`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelNameAbbreviation`;

export const spCatalogCertLogicGrantExtensionLocs: LocDefs<SPCatalogCertLogicGrantExtensionLocNames> =
	{
		SPCatalogCertLogicGrantExtensionTitleSection: {
			defaultValue: 'Credentials that Grant an Extension',
			description: 'Section Title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'Credential/CatalogsCredential.GrantedCerts.Title.SectionTitle',
			...sharedProperties,
		},
		SPCatalogCertLogicGrantExtensionButtonHide: {
			defaultValue: 'Hide',
			description: 'Hide button',
			displayPath: `${pathStart}Hide`,
			displayType: 'Button',
			legacyName: 'Credential/CatalogsCredential.GrantedCerts.Button.Hide',
			...sharedProperties,
		},
		SPCatalogCertLogicGrantExtensionButtonShow: {
			defaultValue: 'Show',
			description: 'Show button',
			displayPath: `${pathStart}Show`,
			displayType: 'Button',
			legacyName: 'Credential/CatalogsCredential.GrantedCerts.Button.Show',
			...sharedProperties,
		},
		SPCatalogCertLogicGrantExtensionLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.GrantedCerts.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCatalogCertLogicGrantExtensionLabelNameAbbreviation: {
			defaultValue: 'Abbreviation',
			description: 'Column heading for: Abbreviation.',
			displayPath: `${pathStart}Abbreviation`,
			displayType: 'Label',
			legacyName: 'Credential/CatalogsCredential.GrantedCerts.ColumnHeading.NameAbbr',
			...sharedProperties,
		},
	};

export type SPCatalogCertLogicGrantExtensionLocType =
	LocMap<SPCatalogCertLogicGrantExtensionLocNames>;
